import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CheckboxProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  ariaLabel: string
  className?: string
  disabled?: boolean
}

export function Checkbox({ checked, onCheckedChange, ariaLabel, className, disabled = false }: CheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        'flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-md border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50 disabled:cursor-not-allowed disabled:opacity-40',
        checked
          ? 'border-accent bg-accent text-white shadow-sm'
          : 'border-border2 bg-bg text-transparent hover:border-accent/70 hover:bg-accent/5',
        className
      )}
    >
      <Check className="h-3.5 w-3.5" />
    </button>
  )
}
